module.exports = __webpack_public_path__ + "static/media/checkout-mobile.a5c6a2db.png";